
import { DateRangeModel } from "../date/date-range.model";
import { BookingResponseModel } from "../../http/response/booking/booking-response.model";

export class MetaDataModel {
    eventSearchDateRange?: DateRangeModel;
    unassignedChannelsCount?: number;
    csvColumnOrder?: string[];
    sampleBooking?: BookingResponseModel;
}